"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageCatalogueLookupResponseSchema = exports.PackageCatalogueLookupResultSchema = exports.PackageCatalogueSummarySchema = exports.PackageCatalogueLookupRequestSchema = exports.PACKAGE_CATALOGUE_LOOKUP_MAX_MPNS = exports.PACKAGE_CATALOGUE_SCHEMA_VERSION = void 0;
const z = require("zod");
exports.PACKAGE_CATALOGUE_SCHEMA_VERSION = 1;
exports.PACKAGE_CATALOGUE_LOOKUP_MAX_MPNS = 100;
exports.PackageCatalogueLookupRequestSchema = z.object({
    mpns: z.array(z.string().trim().min(1).max(256)).min(1).max(exports.PACKAGE_CATALOGUE_LOOKUP_MAX_MPNS),
});
exports.PackageCatalogueSummarySchema = z.object({
    id: z.string().min(1),
    manufacturerPartNumber: z.string(),
    variantSuffix: z.string(),
    manufacturerName: z.string(),
    packageFamilyName: z.string(),
    datasheetUrl: z.string().nullable(),
});
exports.PackageCatalogueLookupResultSchema = z.object({
    mpn: z.string(),
    packages: z.array(exports.PackageCatalogueSummarySchema),
});
exports.PackageCatalogueLookupResponseSchema = z.object({
    schemaVersion: z.number().int(),
    deploymentId: z.string().min(1),
    results: z.array(exports.PackageCatalogueLookupResultSchema),
});
//# sourceMappingURL=package-catalogue-lookup.js.map